import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useFormikContext } from 'formik';
import { UsersApi } from 'services/users/users.api';

import { IPersonalInfoStepValues, IEmailValidationProps as IProps } from 'components/Registration/types';

import ToastService from 'helpers/ToastService';

export const EmailValidation: FC<IProps> = ({ setEmailError }) => {
  const { t } = useTranslation();
  const { values, errors, dirty, touched } = useFormikContext<IPersonalInfoStepValues>();
  const { email: emailValue } = values;
  const { email: emailError } = errors;
  const { email: emailTouched } = touched;

  useEffect((): void => {
    const emailValidation = async () => {
      try {
        if (dirty && emailTouched && !emailError && emailValue.length !== 0) {
          const { registeredAccounts } = await UsersApi.verifyEmail({ email: emailValue });

          if (Object.values(registeredAccounts).includes(true)) {
            return setEmailError(t('emailAlreadyExistsError'));
          }

          setEmailError('');
        }
      } catch (error) {
        if (error instanceof Error) {
          ToastService.showError(error.message);
          setEmailError('');
        }
      }
    };

    emailValidation();
  }, [dirty, emailTouched, emailError, emailValue, setEmailError, t]);

  return null;
};
